import { useRequest } from '~/repositories'

export interface SubscriberRegisterPayload {
	email: string
	name: string
	lottery_id: number
	country_id: number
	numbers?: number[]
}
export interface ValidateRegisterPayload {
	email: string
	lottery_id: number
	country_id: number
	numbers?: number[]
}
export interface SubscriberStatsPayload {
	email: string
}

/** Registers a guest subscriber (email alert) for a lottery/country/numbers combination. */
export const postSubscriberRegister = (payload: SubscriberRegisterPayload) => {
	return useRequest('post', `/v1/subscriber/register/`, payload)
}

/** Validates whether an email is already subscribed for the given lottery/country combination. */
export const postValidateSubscriber = (payload: ValidateRegisterPayload) => {
	return useRequest('post', `/v1/subscriber/validate/`, payload)
}

/** Fetches subscriber stats (e.g. alert count) for a given email. */
export const postSubscriberStats = (payload: SubscriberStatsPayload) => {
	return useRequest('post', `/v1/subscriber/stats/`, payload)
}

export default {
	postSubscriberRegister,
	postValidateSubscriber,
	postSubscriberStats,
}
